module.exports = __webpack_public_path__ + "static/media/blocker_discuss.193844ac.png";